import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { getUserFollowMoveTo } from '../../../../../../../../store/model/authUser/selectors/getUserFollowMoveTo';
import { SegmentCardBooleanValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onDidMount = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const isUserFollowMoveTo = getUserFollowMoveTo(getState());
        dispatch(segmentTrackAction(SegmentCardEvent.MOVE_TO_DROPDOWN_OPENED, {
            name: SegmentCardOptions.MOVE_TO_FOLLOW,
            value: isUserFollowMoveTo ? SegmentCardBooleanValue.TRUE : SegmentCardBooleanValue.FALSE
        }));
    };
    return action;
};
